module.exports = __webpack_public_path__ + "img/link.efb04d1c.png";